import React, { useState, useEffect } from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

// Components
import PurchaseOrderInfoTable from "./PurchaseOrderInfoTable"; //reused table component
import PurchaseAddItem from "./PurchaseAddItem"; //item add modal
import PurchaseEditShipping from "./PurchaseEditShipping"; //update shipping modal

//React Router (for getting parameters)
import { useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";

import MessageBox from "../../components/MessageBox/MessageBox";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import LoadingModal from "../../components/Modal/LoadingModal";
import Preloader from "../../components/Preloader/Preloader";

const useStyles = makeStyles({
  card: {
    marginBottom: "1rem",
  },
  cardHeader: {
    borderBottom: "1px solid #59b259",
    padding: "1.3rem 24px 2rem 24px",
  },
  title: {
    marginTop: "0",
    color: "#339933",
    fontWeight: "700",
    fontSize: "1.1rem",
  },
  subTitle: {
    fontSize: "0.8rem",
    marginBottom: "0.5rem",
    fontWeight: "700",
    textTransform: "uppercase",
    color: "#c1c3d8",
    display: "none",
  },
  infoContainer: {
    marginBottom: "2rem",
    backgroundColor: "rgba(89, 178, 89, 0.09)",
    padding: "1rem",
    border: "1.5px solid #59b259",
    borderRadius: "5px",
  },
  infoTitle: {
    fontWeight: "700",
    fontSize: "14px",
  },
  infoContent: {
    fontSize: "14px",
  },
  buttonContainer: {
    textAlign: "right",
    "& button": {
      marginLeft: "0.5rem !important",
    },
  },
  infoTotal: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: "1rem",
  },
  infoTotalItem: {
    padding: "0.5rem 1rem",
    border: "1px solid #59b259",
    borderRadius: "5px",
    display: "flex",
    alignItems: "center",
    marginBottom: "0.5rem",
    fontWeight: "700",
  },
  infoTotalIcon: {
    marginRight: "0.5rem",
    color: "#4caf50 !important",
  },
  textarea: {
    width: "100%",
    marginTop: "1rem",
  },
});

const PurchaseApprovalHistoryView = () => {
  const { pono, branchidno } = useParams();
  const [supplierInfo, setSupplierInfo] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const classes = useStyles();

  const [items, setItems] = useState([]); //data to display in PO table
  const [supplierItem, setSupplierItem] = useState([]); //data to display in Add Item dropdown

  const [poTotal, setPoTotal] = useState(0);
  const [shipTotal, setShipTotal] = useState(0);
  const [notes, setNotes] = useState("");

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  //state for disabling/enabling button
  const [btnDisabled, setBtnDisabled] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [dataLoaded, setDataLoaded] = useState(false);

  let history = useHistory();

  const addItem = (item) => {
    let found = items.some((x) => x.item_id === item.id);
    if (found) {
      //if item is existing in itemArray, add the qty instead
      let newItems = items.map((it) => {
        if (it.item_id === item.id) {
          //add
          it.qty += item.qty;
        }
        return it;
      });
      setItems(newItems);
    } else {
      //add new unique item to array
      setItems([
        ...items,
        {
          item_id: item.id,
          qty: item.qty,
          price: item.cost,
          uomDesc: item.uomDesc,
          item_name: item.itemname,
        },
      ]);
    }
  };

  const deleteItem = (item_id) => {
    // console.log(item_id);
    let itemArray = items.filter((item) => item.item_id !== item_id);
    setItems(itemArray);
  };

  // componentDidMount / document.ready ?
  useEffect(() => {
    data();
  }, []);

  const x = 0;
  useEffect(() => {
    //
    isLoggedIn();
  }, [x]);

  useEffect(() => {
    let po_total = 0;
    items.forEach((item) => (po_total += item.price * item.qty));
    setPoTotal(po_total);

    if (items.length > 0) {
      setBtnDisabled(false); // re-enable
    } else {
      setBtnDisabled(true); // re-enable
    }
  }, [items]);

  //after getting supplier data, get supplierId and get item for add item dropdown (based on supplierid provided)
  useEffect(() => {
  	if(supplierInfo.supid){
  		axios.get(process.env.REACT_APP_API_URL+'get_supplier_items_list', {
            params: { supplier_id: supplierInfo.supid,jc_idno:get_cookies('branchidno'),
              curcode:get_cookies('curcode'),	country:get_cookies('country'), }
  		}).then(function (response) {
  				setSupplierItem(response.data.data);
          setDataLoaded(true);
  				// console.log(supplierInfo.supid);
  				// console.log(response.data);
  		});
  	}
  }, [supplierInfo]);

  const data = async () => {
    const po_details = await axios.get(
      process.env.REACT_APP_API_URL + "get_po_details",
      {
        params: {
          pono: pono,
          jc_u_idno: branchidno,
        },
      }
    );
    if (po_details) {
      // console.log('4343',po_details); 
      setItems(po_details.data.data[0].item_info);
      setSupplierInfo(po_details.data.data[1].po_info);
      setShipTotal(po_details.data.data[1].po_info.shipping);
      setPoTotal(po_details.data.data[1].po_info.subtotal);
      setNotes(po_details.data.data[1].po_info.notes);
      setWarehouse(po_details.data.data[1].po_info.warehouse_id);
      // setDataLoaded(true);
    }
  };

  const update_po = async () => {
    setShowModal(true); //show loading/please wait modal
    setBtnDisabled(true); // disable button to avoid multiple saves
    // console.log(JSON.stringify(items));

    const formData = new FormData();
    // formData.append("item_array", postItemArray);
    formData.append("item_array", JSON.stringify(items));
    formData.append("supplier_id", supplierInfo.supid);
    formData.append("jc_user_id_no", branchidno);
    formData.append("curcode", get_cookies("curcode"));
    formData.append("shipping", shipTotal);
    formData.append("trandate", supplierInfo.delivery_date);
    formData.append("notes", notes);
    formData.append("jc_username", get_cookies("username"));
    formData.append("warehouse", warehouse);
    formData.append("pono", pono);

    await axios
      .post(process.env.REACT_APP_API_URL + "update_po", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (res) {
        setMsgType('success')
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("PO Updated");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
          history.push("/purchases/purchases-order-approval-history");
        }, 2000);
      })
      .catch(function (error) {
        setShowModal(false); //hide loading/please wait modal
        setShowMsgBox(true);
        setMsg("Something went wrong: " + error);
        setMsgType("warning");
        setTimeout(() => {
          setShowMsgBox(false);
          setBtnDisabled(false); // re-enable
        }, 2500);
      });
  };

  return (
    <div className="page">
      <div className="page-header">
        <div className="page-icon">
          <LoyaltyTwoTone />
        </div>
        <NavLink to={"/purchases"}>
          <h4 style={{ color: "#339933" }}>Purchases</h4>
        </NavLink>
        <ArrowForwardIosIcon fontSize="small" color="disabled" />
        <NavLink to={"/purchases/purchases-order-approval-history"}>
          <h4 style={{ color: "#339933" }}>Purchase Order Approval</h4>
        </NavLink>
        <ArrowForwardIosIcon fontSize="small" color="disabled" />
        <h4>Purchase Order Edit #{pono}</h4>
      </div>
      {dataLoaded ? (
        <div className="page-container">
          <LoadingModal showModal={showModal} />
          <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
          <Card className={classes.card}>
            <div className={classes.cardHeader}>
              <Grid
                container
                spacing={0}
                style={{ justifyContent: "flex-end" }}
              >
                <Grid item xs={12}>
                  <div className={classes.subTitle}>Purchase Order Edit</div>
                  <div className={classes.title}>
                    {supplierInfo.purchase_from || "Purchased From"}
                  </div>
                </Grid>
                {/* <Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								<PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								<PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/>
							</Grid> */}
                <PurchaseEditShipping
                  shipTotal={shipTotal}
                  setShipTotal={setShipTotal}
                />
                <div style={{ marginRight: "0.5em" }}></div>
                <PurchaseAddItem
                  addItem={addItem}
                  supplierItem={supplierItem}
                />
              </Grid>
            </div>
            <CardContent>
              <div className={classes.infoContainer}>
                <Grid container spacing={3}>
                  <Grid item xs={4} className={classes.infoTitle}>
                    Date of Delivery:
                  </Grid>
                  <Grid item xs={8} className={classes.infoContent}>
                    {supplierInfo.delivery_date || "Date of delivery"}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={4} className={classes.infoTitle}>
                    Deliver To:
                  </Grid>
                  <Grid item xs={8} className={classes.infoContent}>
                    {supplierInfo.purchase_from || "Purchased From"}
                  </Grid>
                </Grid>
                {/* <Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Branch
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{supplier.branchidno || "Branch"}
								</Grid>
							</Grid> */}
                <Grid container spacing={3}>
                  <Grid item xs={4} className={classes.infoTitle}>
                    Mode of Payment:
                  </Grid>
                  <Grid item xs={8} className={classes.infoContent}>
                    {supplierInfo.mode_of_payment || "Mode of Payment"}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={4} className={classes.infoTitle}>
                    Contact #:
                  </Grid>
                  <Grid item xs={8} className={classes.infoContent}>
                    {supplierInfo.contact_number || "Contact Number"}
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={4} className={classes.infoTitle}>
                    Address:
                  </Grid>
                  <Grid item xs={8} className={classes.infoContent}>
                    {supplierInfo.address || "Address"}
                  </Grid>
                </Grid>
              </div>
              <PurchaseOrderInfoTable
                items={items}
                setItems={setItems}
                deleteItem={deleteItem}
              />
              <div className={classes.infoTotal}>
                <div className={classes.infoTotalContent}>
                  <div className={classes.infoTotalItem}>
                    <LocalShippingTwoToneIcon
                      className={classes.infoTotalIcon}
                    />
                    {/* Shipping: 0.00	shipTotal	 */}
                    {"Shipping: " + shipTotal}
                  </div>
                  <div className={classes.infoTotalItem}>
                    <ShoppingCartTwoToneIcon
                      className={classes.infoTotalIcon}
                    />
  {"Total: "+ numeral(Number(shipTotal)+Number(poTotal)).format('0,0.00')}
                  </div>
                </div>
              </div>
              <TextField
                label="Notes"
                multiline
                rows={4}
                variant="outlined"
                value={notes || ""}
                className={classes.textarea}
                onChange={(e) => {
                  setNotes(e.target.value);
                }}
              />
            </CardContent>
          </Card>
          <div className={classes.buttonContainer}>
            {/* <Button variant="contained">Back</Button>  */}
            <Button
              disabled={btnDisabled}
              variant="contained"
              color="primary"
              onClick={update_po}
            >
              Update
            </Button>
          </div>
        </div>
      ) : (
        <Preloader />
      )}
    </div>
  );
};

export default PurchaseApprovalHistoryView;
